import React from 'react';

import { Trans, useTranslation } from 'react-i18next';

export const ReadInfoSection = () => {
  const { t } = useTranslation('cart');

  return (
    <div className="mb-8 flex w-full flex-col gap-y-[10px] rounded-2xl border border-gray-200 bg-white px-5 py-5 shadow-sm md:mb-[42px] md:px-9 md:py-[34px]">
      <div className="flex items-center gap-x-2">
        <span className="text-base md:text-xl">📝</span>
        <span className="text-sm font-semibold text-gray-900 md:text-lg">{t('instructions.readCarefully')}</span>
      </div>

      <ul className="ml-4 list-disc space-y-2 text-sm text-[#3f3f3f] md:text-lg">
        <li>
          <Trans i18nKey="cart:instructions.item1" components={{ strong: <strong /> }} />
        </li>
        <li>
          <Trans i18nKey="cart:instructions.item2" components={{ strong: <strong /> }} />
        </li>
        <li>
          <Trans i18nKey="cart:instructions.item3" components={{ strong: <strong /> }} />
        </li>
        <li>
          <Trans i18nKey="cart:instructions.item4" components={{ strong: <strong /> }} />
        </li>
        <li>
          <Trans i18nKey="cart:instructions.item5" components={{ strong: <strong /> }} />
        </li>
      </ul>
    </div>
  );
};
